var List_obj = {};
/**
 * 协议状态集合
 * @type {*[]}
 */

List_obj.protocolStatusList = [{
  codeCode: '00',
  codeName: '全部'
}, {
  codeCode: '02',
  codeName: '待补录'
}, {
  codeCode: '03',
  codeName: '暂存'
}, {
  codeCode: '04',
  codeName: '待审核'
}, {
  codeCode: '05',
  codeName: '生效'
}, {
  codeCode: '06',
  codeName: '审核驳回'
}, {
  codeCode: '07',
  codeName: '待保险公司内部审核'
}, {
  codeCode: '08',
  codeName: '保险公司内部审核驳回'
}];
/* 保险公司审核标识*/

List_obj.companyAuditFlagList = [{
  codeCode: '',
  codeName: '请选择'
}, {
  codeCode: '1',
  codeName: '是'
}, {
  codeCode: '0',
  codeName: '否'
}];
List_obj.trueOrFalse = [{
  codeCode: '1',
  codeName: '是'
}, {
  codeCode: '0',
  codeName: '否'
}];
/**
 * 有无包装
 * @type {*[]}
 */

List_obj.isPackagingFlag = [{
  codeCode: '1',
  codeName: '有'
}, {
  codeCode: '0',
  codeName: '无'
}];
List_obj.inSureTypeList = [{
  placeholder: '请输入被保险人名称',
  name: '被保险人名称',
  input: 'insuredName',
  type: 'input'
}, {
  placeholder: '请输入被保险人英文名称',
  name: '被保险人英文名称',
  input: 'insuredEnName',
  type: 'input'
}, {
  placeholder: '请选择证件类型',
  name: '证件类型',
  input: 'idEntifyTypeCode',
  type: 'select'
}, {
  placeholder: '请输入证件号',
  name: '证件号',
  input: 'identifyNumber',
  type: 'input'
}, {
  placeholder: '请输入地址',
  name: '地址',
  input: 'address',
  type: 'input'
}, {
  placeholder: '请输入邮箱',
  name: '邮箱',
  input: 'email',
  type: 'input'
}, {
  placeholder: '请输入电话',
  name: '电话',
  input: 'phone',
  type: 'input'
}];
List_obj.clauseAttributeList = [{
  codeCode: '1',
  codeCname: '主险'
}, {
  codeCode: '2',
  codeCname: '附加险'
}];
/**
 * 可选费率因子
 * @type {Array}
 */

List_obj.freightRateList = [{
  codeCode: '1',
  codeCname: '运输区间'
}, {
  codeCode: '2',
  codeCname: '是否集装箱'
}, {
  codeCode: '3',
  codeCname: '包装'
}, {
  codeCode: '4',
  codeCname: '运输方式'
}, {
  codeCode: '5',
  codeCname: '特殊加成比例'
}];
List_obj.selectCondList = [{
  codeCode: '1',
  codeCname: '标的类型'
}, {
  codeCode: '2',
  codeCname: '运输方式'
}, {
  codeCode: '3',
  codeCname: '是否冷藏'
}, {
  codeCode: '4',
  codeCname: '有无包装'
}],
/**
 * 可选影响因子
 * @type {*[]}
 */
List_obj.influenceList = [{
  codeCode: '1',
  codeCname: '运输方式'
}, {
  codeCode: '2',
  codeCname: '标的'
}];
/**
 * 新旧标标志
 * @type {*[]}
 */

List_obj.newOrOldStates = [{
  codeCode: '1',
  codeCname: '新'
}, {
  codeCode: '2',
  codeCname: '旧'
}];
export default List_obj;